import { render, staticRenderFns } from "./SurveyQuestionCard.vue?vue&type=template&id=df348b7a"
import script from "./SurveyQuestionCard.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports